import script from "./searchDropdownMain.vue?vue&type=script&setup=true&lang=js"
export * from "./searchDropdownMain.vue?vue&type=script&setup=true&lang=js"

import "./searchDropdownMain.vue?vue&type=style&index=0&id=72553518&lang=css"

const __exports__ = script;

export default __exports__